import React from 'react';
import { Route } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });

  return paths;
};

const BreadcrumbsItem = ({ ...rest, match }) => {
    let routeName = match.url.split('/').slice(-1).pop();
    if (routeName === '') routeName = 'Home';
    if (routeName) {
        return (
            match.isExact ?
            (
                <BreadcrumbItem active>{routeName}</BreadcrumbItem>
            ) : (
                <LinkContainer to={match.url || ''}>
                    <BreadcrumbItem>
                        {routeName}
                    </BreadcrumbItem>
                </LinkContainer>
            )
        );
    }
    return null;
};

const Breadcrumbs = ({ ...rest, location : { pathname }, match }) => {
  const paths = getPaths(pathname);
  return (
    <Breadcrumb>
      {paths.map(p => <Route key={p} path={p} component={BreadcrumbsItem} />)}
    </Breadcrumb>
  );
};

export default props => (
    <Route path="/:path" component={Breadcrumbs} {...props} />
);


// WEBPACK FOOTER //
// ./src/App/Breadcrumbs.js